import { HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { BehaviorSubject, Observable, Subject} from 'rxjs';
import { isNullOrUndefined } from 'src/app/services/utils';
import { environment } from '../../environments/environment';
import { COMMON_CONSTANTS, MANAGE_LINE_CONST, SUSPEND_CONSTANTS, BULK_UPLOAD, IDP_SOC_LIST} from '../common/core/common.constants';
import { EnvironmentDetailsService } from './environment-details.service';
import { HttpCacheService } from './http-cache.service';
import { AuthHttpService } from './http-wrapper.service';
import { LoaderService } from './loader.service';
import { UtilsService } from './utils.service';
import { RequestsLineIdentifier } from '../common/models/data.model';
import { ContentService } from './content.service';
import { HelperUtilityService } from './helper-utility.service';
import * as XLSX from 'xlsx';
@Injectable({
  providedIn: 'root',
})
export class ManageLineService   {

  authToken: any;
  orgID: any;
  step: any;
  userId: any;
  searchValueDynamic: any;


  public paperlessBillingDetails = new BehaviorSubject(null);
  public banFriendlyName = new BehaviorSubject(null);

  private modifyCurrentSelection = new BehaviorSubject(null);
  public notifyChangeNumberFlow = new Subject();
  public ExceltoJson = new Subject();

  public notifySingleSetting = new Subject();
  public storeMultiLineData: any = null;
  public changeNumberFlowResponseBody = [];
  public callCounter = 0;
  currentSelection = this.modifyCurrentSelection.asObservable();
  private stickyFooterFunctionality = new BehaviorSubject(null);
  stickyFooterImplimentation = this.stickyFooterFunctionality.asObservable();
  private transactionCompleted = new BehaviorSubject(false);
  transactionStatus = this.transactionCompleted.asObservable();
  private callHeaderFunction = new BehaviorSubject(null);
  settingHeaderValue = this.callHeaderFunction.asObservable();
  public isCheckBoxDisabled = true;
  searchError = false;
  public clickManageAccount = new Subject<boolean>();
  enableConfigurationAPICall: boolean;
  public notifyService = new BehaviorSubject(null);
  public notifyServiceTransaction = new BehaviorSubject(null);
  public notifyLineDetailTransations = new BehaviorSubject(null);
  public noRecordsFound = new Subject<boolean>();
  public cancelDialpadLicenseDecrement = new Subject();
  public callFetchNotification = new BehaviorSubject(null);
  private customizeOptions = new BehaviorSubject(null);
  customizeAllOptions = this.customizeOptions.asObservable();
  euiCodeData: { code: string; euiKey: any; redirectUri: string; };
  authTokenForFileUpload: string;
  public billingAddressUpdated = new Subject<boolean>();
  httpClient: AuthHttpService;
  _utilsSvc: UtilsService;
  modalService: NgbModal;
  router: Router;
  _envSvc: EnvironmentDetailsService;
  _cacheSvc: HttpCacheService;
  _loaderSvc: LoaderService;
  contentService: ContentService;
  _helperUtilSvc: HelperUtilityService
  euiTokenData: any;
  email: any;

  constructor(private injector : Injector) {
    this.httpClient = this.injector.get<AuthHttpService>(AuthHttpService);
    this._utilsSvc = this.injector.get<UtilsService>(UtilsService);
    this.modalService = this.injector.get<NgbModal>(NgbModal);
    this.router = this.injector.get<Router>(Router);
    this._envSvc = this.injector.get<EnvironmentDetailsService>(EnvironmentDetailsService);
    this._cacheSvc = this.injector.get<HttpCacheService>(HttpCacheService);
    this._loaderSvc = this.injector.get<LoaderService>(LoaderService);
    this.contentService = this.injector.get<ContentService>(ContentService);
    this._helperUtilSvc = this.injector.get<HelperUtilityService>(HelperUtilityService);
    this.authToken = !isNullOrUndefined(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY)) ?
      COMMON_CONSTANTS.HEADER_PROPERTIES.BEARER_KEY + this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY) : '';
    this.orgID = this._helperUtilSvc.getOrgID();

    this.euiTokenData= JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.EUI_TOKEN_DATA));
    this.email = !isNullOrUndefined(this.euiTokenData) ? this.euiTokenData.logonId: '';
  }

  setHeaders() {
    this.authToken = !isNullOrUndefined(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY)) ?
      COMMON_CONSTANTS.HEADER_PROPERTIES.BEARER_KEY + this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY) : '';
    this.orgID = this._helperUtilSvc.getOrgID();
    return {
      headers: new HttpHeaders(
        {
          'Accept': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'Content-Type': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'Cache-Control': COMMON_CONSTANTS.HEADER_PROPERTIES.NO_CACHE,
          // 'Authorization': this.authToken,
          'B2b-Client': this._helperUtilSvc.getClientId() || '',
          'B2b-Org': this.orgID || '',
          'authType': this._helperUtilSvc.getAuthType() || '',
          'transactionID': this._helperUtilSvc.getTransactionID() || '',
          'authToken':this._helperUtilSvc.getAuthToken() || '',
        },
      ),
    };
  }

  setHeadersForRatePlanandservicesAPiCall(){
    this.authToken = !isNullOrUndefined(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY)) ?
    COMMON_CONSTANTS.HEADER_PROPERTIES.BEARER_KEY + this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY) : '';
  return {
    headers: new HttpHeaders(
      {
        'Accept': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
        'Content-Type': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
        'Cache-Control': COMMON_CONSTANTS.HEADER_PROPERTIES.NO_CACHE,
        // 'Authorization': this.authToken,
        'B2b-Client': this._helperUtilSvc.getClientId() || '',
        'B2b-org': this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.IS_OLM_ORG) || this._helperUtilSvc.getOrgID(),
        'authType': this._helperUtilSvc.getAuthType() || '',
        'transactionID': this._helperUtilSvc.getTransactionID() || '',
        'authToken':this._helperUtilSvc.getAuthToken() || '',
      },
    ),
  };
  }

  changeCustomizedColumns(obj) {
    this.customizeOptions.next(obj);
  }

  getManageLineDetail(ban, pageNumber, lineStatus?: string[], isTotalMsisdns: boolean = false) {
    const httpOptions = this.setHeaders();
    let acctInfoUrl;
      const reqBody = {
        'pageNumber': pageNumber,
        // 'pageSize': 999,
        'pageSize': COMMON_CONSTANTS.RECORDS_PER_PAGE_TEA_API,
        'billingAccount': ban,
      };

      if(environment.ENABLE_REMOVE_CANCELED_LINES && lineStatus != undefined){
        reqBody["lineStatus"] = lineStatus
      }
      
      // if totalMsisdnsInUse is required in response
      if(isTotalMsisdns) {
        reqBody["getTotalMsisdnsInUse"] = isTotalMsisdns;
      }

      // subscriber line details TEA API
      acctInfoUrl = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SUBSCRIBER_LINE_DETAILS_TEA_API;
      if (environment.mocked_all || environment.mocked_endpoints) {
        return this.httpClient.get(acctInfoUrl);
      } else {
        return this.httpClient.post(acctInfoUrl, reqBody, httpOptions);
      }
    }

  getLineDetailSubscrierDetails(ban, msisdn) {
    const httpOptions = this.setHeaders();
    let subscriberDetailsUrl: any;
    if (environment.ENABLE_TEA_API) {
      const reqBody = {
        'billingAccount': ban,
        'msisdn': msisdn
      };

      // subscriber line details TEA API
      subscriberDetailsUrl = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SUBSCRIBER_LINE_DETAILS_TEA_API;
      if (environment.mocked_all || environment.mocked_endpoints) {
        return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SUBSCRIBER_LINE_DETAILS_TEA_API_LINEDETAILSPAGE);
      } else {
        return this.httpClient.post(subscriberDetailsUrl, reqBody, httpOptions);
      }
    }
  }

  getLineDetailsAPI(ban,msisdn){
    const httpOptions = this.setHeaders();
    let lineDetailsUrl: any;
    if (environment.ENABLE_TEA_API) {
      const reqBody = {
        'request':{
        'billingAccountNumber': ban,
        'msisdn': msisdn,
        'filter': COMMON_CONSTANTS.INCLUDE_MSISDN
        }
      };
      // line details TEA API
      lineDetailsUrl = this._envSvc.APIGEE_TOKEN_URLS.LINE_DETAILS_TEA_API;
      if (environment.mocked_all || environment.mocked_endpoints) {
        return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.LINE_DETAILS_TEA_API);
      } else {
        return this.httpClient.post(lineDetailsUrl, reqBody, httpOptions);
      }
    }
  }

  getPlanServiceDetails(ban) {
    const httpOptions = this.setHeaders();
    const planServiceUrl = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_MANAGE_PLAN_SERVICES_API;

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(planServiceUrl);
    } else {
      const body = {
        'billingAccount': ban
      }
      return this.httpClient.post(planServiceUrl, body, httpOptions);
    }
  }
  close(loaderStatus?: boolean) {
    this.modalService.dismissAll();
    if (!loaderStatus) {
      this._loaderSvc.stop();
    }
  }
  closeSuccessPopup(isLineDetailsWindow?) {
    this.modalService.dismissAll();
    this._loaderSvc.stop();
    isLineDetailsWindow ? this.notifyLineDetailTransations.next(true) : this.notifyService.next(true);

  }
  openTransactions() {
    let currentURL = this.router.url;
    if (currentURL == MANAGE_LINE_CONST.REDIRECT_TO_TRANSACTION_HISTORY) {
      this.notifyServiceTransaction.next(true);
    } else {
      this.notifyServiceTransaction.next(false);
    }
  }

  submitBanForm() {

    this.modalService.dismissAll();
    this._loaderSvc.stop();
    this.router.navigate([MANAGE_LINE_CONST.REDIRECT_TO_MANAGE_LINES]);
  }

  checkSearchError() {
    return this.searchError;
  }
  setStep(index: number) {
    this.step = index;
  }
  nextStep() {
    this.step++;
  }

  changeCurrentSelection(line: any) {
    let list = [];
    if (!isNullOrUndefined(line) && line === SUSPEND_CONSTANTS.CLOSE_SUSPEND_MODAL) {
      this.modifyCurrentSelection.next(SUSPEND_CONSTANTS.CLOSE_SUSPEND_MODAL);
    } else {
      if (!isNullOrUndefined(line.msisdn)) {
        line.fromreviewModal = false;
        list.push(line);
      } else {
        list = line;
      }
      this.modifyCurrentSelection.next(list);
    }
  }

  shareCurrentSelection(type) {
    this.modifyCurrentSelection.next({ type });
  }

  clearCurrentSelection() {
    this.modifyCurrentSelection.next(null);
  }

  completeTransaction(status: boolean) {
    this.transactionCompleted.next(status);
  }

  callingHeaderMethod(flag) {
    this.callHeaderFunction.next(flag);
  }

  suspendReasons(): Observable<any> {
    const httpOptions = this.setHeaders();
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SUSPEND_REASONS);
    } else {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SUSPEND_REASONS, httpOptions);
    }
  }

  simChangeReasons(): Observable<any> {
    const httpOptions = this.setHeaders();
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SIM_CHANGE_REASONS);
    } else {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SIM_CHANGE_REASONS, httpOptions);
    }
  }

  suspendApprovalTypes(reasonCode): Observable<any> {
    const httpOptions =
    {
      ...this.setHeaders(),
      params:{
        "reason-code":reasonCode
      }
    }
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SUSPEND_APPROVAL_TYPES);
    } else {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SUSPEND_APPROVAL_TYPES, httpOptions);
    }
  }

  suspensionEligibility(requestBody): Observable<any> {
    const httpOptions = this.setHeaders();
    let suspensionEligibilityURL = _.cloneDeep(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SUSPENSION_ELIGIBILITY);
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SUSPENSION_ELIGIBILITY);
    } else {
      return this.httpClient.post(suspensionEligibilityURL, requestBody, httpOptions);
    }
  }
  simChangeEligibility(requestBody): Observable<any> {
    const httpOptions = this.setHeaders();
    let simChangeEligibilityURL = _.cloneDeep(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SIM_CHANGE_ELIGIBILITY);
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SIM_CHANGE_ELIGIBILITY);
    } else {
      return this.httpClient.post(simChangeEligibilityURL, requestBody, httpOptions);
    }
  }

  serviceSuspension(requestSuspension) {
    const httpOptions = this.setHeaders();
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SERVICE_SUSPENSION);
    } else {
      // tslint:disable-next-line:max-line-length
      const serviceSuspensionNewUrl= _.cloneDeep(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SERVICE_SUSPENSION);
      return this.httpClient.post(serviceSuspensionNewUrl, requestSuspension, httpOptions);
    }
  }

  serviceCancelEligibility(requestbody) {
    const httpOptions = this.setHeaders();
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_CANCEL_SUBSCRIBER_ELIGIBILITY);
    } else {
      const serviceCancelEligibilityNewUrl = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_CANCEL_SUBSCRIBER_ELIGIBILITY;
      return this.httpClient.post(serviceCancelEligibilityNewUrl, requestbody, httpOptions);
    }
  }
  submitCancelSubscriber(requestbody) {
    const httpOptions = this.setHeaders();
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SUBMIT_CANCEL_SUBSCRIBER);
    } else {
      const submitCancelSubscriberNewUrl = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SUBMIT_CANCEL_SUBSCRIBER;
      return this.httpClient.post(submitCancelSubscriberNewUrl, requestbody, httpOptions);
    }
  }

  bulkSuspend(requestSuspension) {
    let responseObj: any;
    const httpOptions = this.setHeaders();
    const serviceSuspensionURL = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_BULK_SUSPEND;
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_BULK_SUSPEND);
    } else {
      responseObj = this.httpClient.post(serviceSuspensionURL, requestSuspension, httpOptions);
    }
    return responseObj;
  }
  implimentStickyFooterFunctionality(index) {
    this.stickyFooterFunctionality.next(index);
  }

  simChange(requestSimChange: any) {
    const httpOptions = this.setHeaders();
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SIM_CHANGE);
    } else {
      const simChangeNewUrl = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SIM_CHANGE;
      return this.httpClient.post(simChangeNewUrl, requestSimChange, httpOptions);
    }

  }

  bulkSimChangeProcessor(requestbulkSimChange) {
    let responseObj: any;
    const httpOptions = this.setHeaders();
    const serviceSuspensionURL = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SIM_SWAP_BULK_PROCESSOR;
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SIM_SWAP_BULK_PROCESSOR);
    } else {
      responseObj = this.httpClient.post(serviceSuspensionURL, requestbulkSimChange, httpOptions);
    }
    return responseObj;
  }

  getSubscriberStatus(msisdn): Observable<any> {
    const httpOptions = this.setHeaders();
    let subcriberURL = _.cloneDeep(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SUBSCRIBER_STATUS);
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(subcriberURL);
    } else {
      let requestSubscriberStatus = {
        "mobileNumber" : msisdn
      }
      return this.httpClient.post(subcriberURL, requestSubscriberStatus, httpOptions);
    }
  }

  getRestorationEligibility(request): Observable<any> {
    const httpOptions = this.setHeaders();
    let eligibilityRequestURL = _.cloneDeep(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_RESTORATION_ELIGIBILITY);
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(eligibilityRequestURL);
    } else {
      return this.httpClient.post(eligibilityRequestURL, request, httpOptions);
    }
  }

  serviceRestore(requestRestore) {

    const httpOptions = this.setHeaders();
    requestRestore.orgId = !isNullOrUndefined(this.orgID) ? this.orgID : '';

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SERVICE_RESTORE);
    } else {
      // tslint:disable-next-line:max-line-length
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SERVICE_RESTORE, requestRestore, httpOptions);
    }
  }

  bulkServiceRestore(bulkRequestRestore) {
    let responseObj: any;
    const httpOptions = this.setHeaders();
    const serviceRestoreURL = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_BULK_SERVICE_RESTORE;
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_BULK_SERVICE_RESTORE);
    } else {
      responseObj = this.httpClient.post(serviceRestoreURL, bulkRequestRestore, httpOptions);
    }
    return responseObj;
  }

  bulkLineIdentifierProcessor(payload) {
    const httpOptions = this.setHeaders();
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_LINE_IDENTIFIER_BULK_PROCESSOR);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_LINE_IDENTIFIER_BULK_PROCESSOR, payload, httpOptions);
    }
  }

  changeNumberReasons(): Observable<any> {
    const httpOptions = this.setHeaders();
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_NUMBER_CHANGE_REASON);
    } else {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_NUMBER_CHANGE_REASON, httpOptions);
    }
  }

  changeNumberRequest(body) {
    const httpOptions = this.setHeaders();
    const changeNumberRequestNewUrl = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_NUMBER_CHANGE_REQUEST;

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(changeNumberRequestNewUrl);
    } else {
      return this.httpClient.post(changeNumberRequestNewUrl, body, httpOptions);
    }
  }

  changeNumberEligibility(requestBody): Observable<any> {
    const httpOptions = this.setHeaders();
    let eligibilityChangeNumberRequestURL = _.cloneDeep(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_NUMBER_CHANGE_ELIGIBILITY);
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(eligibilityChangeNumberRequestURL);
    } else {
      return this.httpClient.post(eligibilityChangeNumberRequestURL, requestBody, httpOptions);
    }
  }

  NpaNxxLookupServiceRequest(code, queryType) {
    const httpOptions = this.setHeaders();
    queryType = queryType ? queryType : 'area_code';
    const NPA_NXX_LOOKUP = _.cloneDeep(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_NPA_NXX_LOOKUP);
    const npxNpaUrl = this.httpClient.regeneratePath(NPA_NXX_LOOKUP,
      NPA_NXX_LOOKUP.path + NPA_NXX_LOOKUP.queryparam[queryType] + code);
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(npxNpaUrl);
    } else {
      return this.httpClient.get(npxNpaUrl, httpOptions);
    }
  }

  bulkChangeNmberProcessor(requestbulkChangeNumber) {
    let responseObj: any;
    const httpOptions = this.setHeaders();
    const serviceSuspensionURL = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_CHANGE_NUMBER_BULK_PROCESSOR;
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_CHANGE_NUMBER_BULK_PROCESSOR);
    } else {
      responseObj = this.httpClient.post(serviceSuspensionURL, requestbulkChangeNumber, httpOptions);
    }
    return responseObj;
  }

  UploadLatest(file) {

    const fileUpload = file;

    if (fileUpload) {
      if (typeof (FileReader) !== 'undefined') {
        const reader = new FileReader();
        if (reader.readAsBinaryString) {
          reader.onload = (e: any) => {
            this.ProcessExcel(e.target.result);
          };
          reader.readAsBinaryString(fileUpload);
        } else {
          reader.onload = (e: any) => {
            let data = '';
            const bytes = new Uint8Array(e.target.result);
            for (let i = 0; i < bytes.byteLength; i++) {
              data += String.fromCharCode(bytes[i]);
            }
            this.ProcessExcel(data);
          };
          reader.readAsArrayBuffer(fileUpload);
        }
      } else {
        alert('This browser does not support HTML5.');
      }
    } else {
      alert('Please upload a valid Excel file.');
    }

  }
  ProcessExcel(data) {
    const workbook = XLSX.read(data, {
      type: 'binary',
      dateNF: 'mm/dd/yyyy',
      // defval: '',
    });

    const firstSheet = workbook.SheetNames[0];
    const excelRows = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheet], { raw: false, defval: '' });
    this.ExceltoJson.next(excelRows);
  }

  transferNunmberSingleLine(requestPayLoadTransferNumber) {
    const httpOptions = this.setHeaders();
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_TRANSFER_NUMBER_REQUEST);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_TRANSFER_NUMBER_REQUEST, requestPayLoadTransferNumber, httpOptions);
    }


  }

  transferNumberSingleLineEligibilty(requestPayLoadTransferNumberEligibilty) {
    const httpOptions = this.setHeaders();
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_TRANSFER_NUMBER_ELIGIBITY_REQUEST);
    } else {
      //mock response
      // return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_TRANSFER_NUMBER_ELIGIBITY_REQUEST);
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_TRANSFER_NUMBER_ELIGIBITY_REQUEST,
        requestPayLoadTransferNumberEligibilty, httpOptions);
    }

  }

  bulkTransferNumberProcessor(requestbulkTransferNumber) {
    const httpOptions = this.setHeaders();
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_TRANSFER_NUMBER_BULK_PROCESSOR);
    } else {
      //mock response
      // return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_TRANSFER_NUMBER_BULK_PROCESSOR);
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_TRANSFER_NUMBER_BULK_PROCESSOR, requestbulkTransferNumber, httpOptions);
    }
  }

  setHeadersConfiguratoinSubscriber() {
    this.authToken = !isNullOrUndefined(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY)) ?
      COMMON_CONSTANTS.HEADER_PROPERTIES.BEARER_KEY + this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY) : '';
    return {
      headers: new HttpHeaders(
        {
          'Accept': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'Content-Type': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'Cache-Control': COMMON_CONSTANTS.HEADER_PROPERTIES.NO_CACHE,
          // 'Authorization': this.authToken,
          'B2b-Client': this._helperUtilSvc.getClientId(),
          'B2b-Org': this._helperUtilSvc.getOrgID(),
          'authType': this._helperUtilSvc.getAuthType(),
          'transactionID': this._helperUtilSvc.getTransactionID(),
          'authToken':this._helperUtilSvc.getAuthToken(),
        },
      ),
    };
  }

  fetchConfiguration() {
    const httpOptions = this.setHeaders();

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.ENTITLEMENTS_FETCH_CONFIGURATIONS_AM_EXP_NEW);
    } else {
      let apiUrl: any;
      if(environment.ENABLE_NEW_CONFIGURATION_API || environment.ENABLE_CUP_NOREGRETS_UDF) {
        apiUrl = this._envSvc.APIGEE_TOKEN_URLS.ENTITLEMENTS_FETCH_CONFIGURATIONS_AM_EXP_NEW;
      }
      return this.httpClient.get(apiUrl, httpOptions);
    }
  }

  updateLineIdentifier(requestPayLoadlineidentifier) {
    const httpOptions = this.setHeaders();

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_LINE_IDENTIFIER_CHANGE);
    } else {
      return this.httpClient.put(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_LINE_IDENTIFIER_CHANGE, requestPayLoadlineidentifier, httpOptions);
    }

  }

  GetAllBanResourceGroup() {

    const httpOptions = this.setHeaders();
    let resourceGroupUrl: any;

    resourceGroupUrl = this.httpClient.regeneratePath(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_ENTITLEMENT_RESOURCE_GROUP,
      this._envSvc.APIGEE_TOKEN_URLS.APIGEE_ENTITLEMENT_RESOURCE_GROUP.path.replace('{{user}}',
        this._helperUtilSvc.getUserId()) +
      this._envSvc.APIGEE_TOKEN_URLS.APIGEE_ENTITLEMENT_RESOURCE_GROUP.queryparam.org + this._helperUtilSvc.getOrgID());

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_ENTITLEMENT_RESOURCE_GROUP);
    } else {
      return this.httpClient.get(resourceGroupUrl, httpOptions);
    }
  }

  GetAllBanResource(groupId: any): Observable<any> {
    const httpOptions = this.setHeaders();
    let resourceGroupUrl: any;

    const resourceGroupUrl1 = this.httpClient.regeneratePath(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_RESOURCES_TEAAPI,
      this._envSvc.APIGEE_TOKEN_URLS.APIGEE_RESOURCES_TEAAPI.path.replace(MANAGE_LINE_CONST.ORGID_PLCHOLDER,
        this._helperUtilSvc.getOrgID()) + this._envSvc.APIGEE_TOKEN_URLS.APIGEE_RESOURCES_TEAAPI.queryparam.banFilter + 'false' +
      this._envSvc.APIGEE_TOKEN_URLS.APIGEE_RESOURCES_TEAAPI.queryparam.groupIdParams + groupId +
      ']]');

    resourceGroupUrl = this.httpClient.regeneratePath(resourceGroupUrl1,
      resourceGroupUrl1.path.replace('{{user}}', this._helperUtilSvc.getUserId())
    );

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(resourceGroupUrl);
    } else {
      return this.httpClient.get(resourceGroupUrl, httpOptions);
    }
  }

  getLindIdentifierRequestHeader() {
    const requestLineIdentifier = new RequestsLineIdentifier();
    requestLineIdentifier.billingAccount = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.BAN_NUMBER_KEY);
    return requestLineIdentifier;
  }

  lineUpgradeEligibility(msisdn: any): Observable<any> {
    this.orgID = this._helperUtilSvc.getOrgID();
    const httpOptions = this.setHeaders();
    const reqBody = {
      msisdn: msisdn.split(" "),
      jumpCheck: COMMON_CONSTANTS.TRUE_TXT,
      blackberryCheck: COMMON_CONSTANTS.FALSE_VAL,
      subsidyCheck: COMMON_CONSTANTS.FALSE_VAL
    }
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_GET_UPGRADE_ELIGIBILITY);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_GET_UPGRADE_ELIGIBILITY, reqBody, httpOptions);
    }
  }

  getLoanHistory(ban: any, msisdn: any): Observable<any> {
    var httpOption = {};
    var requestBody = {};

      httpOption = {
        ...this.setHeaders(),
        headers: {
          'activity-id': this._helperUtilSvc.getTransactionID() || ''
        }
      }
       requestBody ={
        billingAccountNumber:ban,
        mobileNumber: msisdn
      };

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_GET_LOAN_HISTORY_NEW);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_GET_LOAN_HISTORY_NEW,requestBody, httpOption);
    }
  }

  getAccountManagerList(ban?: any, productType?: string, roles?: any) {
    this.orgID = this._helperUtilSvc.getOrgID();
    const httpOptions = this.setHeaders();
    const reqBody = {
      orgId: this.orgID,
      billingAccount: ban,
      productType: productType,
      roles: roles
    }
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_ACCOUNT_MANAGER);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_ACCOUNT_MANAGER, reqBody, httpOptions);
    }
  }
  // get rate plan details

  getChangeRatePlans(payload) {
    const httpOptions = environment.ENABLE_SPECTRUM ? this.setHeadersForRatePlanandservicesAPiCall():this.setHeaders();
    const changeRatePlanURL = this._envSvc.APIGEE_TOKEN_URLS.CHANGE_RATE_PLAN;
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.CHANGE_RATE_PLAN);
    } else {
      return this.httpClient.post(changeRatePlanURL, payload, httpOptions);
    }
  }

  // get services for selectedRatePlan

  getServicesForSelectedRatePlan(payload) {
    const httpOptions = environment.ENABLE_SPECTRUM ? this.setHeadersForRatePlanandservicesAPiCall():this.setHeaders();
    const getServicePlanURL = this._envSvc.APIGEE_TOKEN_URLS.SELECT_SERVICES;
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.SELECT_SERVICES);
    } else {
      return this.httpClient.post(getServicePlanURL, payload, httpOptions);
    }
  }

  //submit api for rateplan
  callSubmitRatePlanApi(payload){
    const httpOptions = this.setHeaders();
    const submitRatePlanURL = this._envSvc.APIGEE_TOKEN_URLS.APGIEE_SUBMIT_RATEPLAN;
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APGIEE_SUBMIT_RATEPLAN);
    } else {
      return this.httpClient.post(submitRatePlanURL, payload, httpOptions);
    }
  }
  getEmailConfirmation(payload){
    const httpOptions = this.setHeaders();
    const emailConfirmationURL = this._envSvc.APIGEE_TOKEN_URLS.EMAIL_CONFIRMATION;
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.EMAIL_CONFIRMATION);
    } else {
      return this.httpClient.post(emailConfirmationURL, payload, httpOptions);
    }
  }
  // get MsisdinDetails

  getMsisdinDetails() {
    const payload = {
      "userId": this._helperUtilSvc.getUserId(),
      "productType": "AH",
      "msisdnFilter": "ALL",
      "pageNumber": "1",
      "pageSize": "99"
    }
    const httpOptions = this.setHeaders();
    const url = this.httpClient.regeneratePath(this._envSvc.APIGEE_TOKEN_URLS.GET_MISDIN_DETAILS,
      this._envSvc.APIGEE_TOKEN_URLS.GET_MISDIN_DETAILS.path.replace('{{orgID}}', this.orgID));

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.GET_MISDIN_DETAILS);
    } else {
      return this.httpClient.post(url, payload, httpOptions);
    }
  }

  getBanBillingAddress(ban: any) {
    const httpOptions = {
      ...this.setHeaders()
    }
    const banId = {
      "ban":ban
    }

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_BAN_ADDRESS_DETAILS);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_BAN_ADDRESS_DETAILS, banId, httpOptions);
    }
  }

  updateBillingAddress(requestPayLoadUpdateAddress: any) {
    const httpOptions = this.setHeaders();
    const url = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_BAN_ADDRESS_UPDATE;

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_BAN_ADDRESS_UPDATE);
    } else {
      return this.httpClient.put(url, requestPayLoadUpdateAddress, httpOptions);
    }
  }

  getSuspensionStatus(ban: any) {
    const httpOptions = this.setHeaders();
    const reqBody = {
      billingAccount: ban
    };

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_DELIQUENCY_CHECK);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_DELIQUENCY_CHECK, reqBody, httpOptions);
    }
  }

  getAutopayEligibility(ban: any, paytype: any) {
    const httpOptions = {
      ...this.setHeaders(),
      headers: {
        'activity-id': this._helperUtilSvc.getTransactionID() || ''
      },
      observe: "response"
    }
    const payload = {
      billingAccount: ban
    }
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_AUTOPAY_ELIGIBILITY_API);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_AUTOPAY_ELIGIBILITY_API, payload, httpOptions);
    }
  }

  getAutoPayInfo(ban:string){
    const httpOptions = {
      ...this.setHeaders(),
      headers: {
        'activity-id': this._helperUtilSvc.getTransactionID() || ''
      }
    }
    const reqBody = {
       customerReference: {
         customerId: ban
       },
       payment: {
         billerCode: COMMON_CONSTANTS.SAMSON_BILLER_CODE,
         businessSegment: COMMON_CONSTANTS.POSTPAID_BUSINESS_SEGEMENT,
         businessUnit: COMMON_CONSTANTS.TMOBILE_BUSINESS_UNIT,
         programCode: COMMON_CONSTANTS.U1POSTPAIDLEGACY_PROGRAMCODE
       }
     }

    if (environment.mocked_all || environment.mocked_endpoints) {
      //mocked endpoint response json
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_AUTOPAY_INFO_API);
    } else {
      //actual call
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_AUTOPAY_INFO_API, reqBody, httpOptions);
    }
  }
  getAutoPayDiscountEligibility(ban:string, alias: string, isCardInfo:boolean){
    const httpOptions = {
      ...this.setHeaders(),
      headers: {
        'activity-id': this._helperUtilSvc.getTransactionID() || ''
      }
    }
    let aliasType:string = "";

    if(isCardInfo){
      aliasType = "paymentCardAlias";
    }else{
      aliasType = "bankAccountAlias";
    }

    const reqBody = {
      salesChannelId: COMMON_CONSTANTS.WEB_SALES_CHANNEL_ID,
      programCode: COMMON_CONSTANTS.U1POSTPAIDLEGACY_PROGRAMCODE,
      businessUnit: COMMON_CONSTANTS.TMOBILE_BUSINESS_UNIT,
      businessSegment: COMMON_CONSTANTS.POSTPAID_BUSINESS_SEGEMENT,
      productGroup: COMMON_CONSTANTS.SOFT_GOODS_PRODUCT_GROUP,
      orderTypes: COMMON_CONSTANTS.MANAGE_PAYMENT_ORDER_TYPES,
      billerCode: COMMON_CONSTANTS.SAMSON_BILLER_CODE,
      accountInfo: {
        billingAccount: ban
      },
      autoPayInfo: {
        autoPayFlow: COMMON_CONSTANTS.QUERY_AUTOPAY_FLOW,
        currentAutoPayInfo: {
          [aliasType]: alias
        }
      }
    }

    if (environment.mocked_all || environment.mocked_endpoints) {
      //mocked endpoint response json
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_AUTOPAY_DISCOUNT_ELIGIBILITY_API);
    } else {
      //actual call
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_AUTOPAY_DISCOUNT_ELIGIBILITY_API, reqBody, httpOptions);
    }
  }

  updateFriendlyName(ban: string, banFriendlyName: string) {
    this.orgID = this._helperUtilSvc.getOrgID();
    const httpOptions = this.setHeaders();
    const reqBody = {
      banNameRequest: [
        {
          banFriendlyName: !isNullOrUndefined(banFriendlyName) ? banFriendlyName : '',
          financialAccountNumber: !isNullOrUndefined(ban) ? ban : '',
        }
      ]
    };

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_BAN_FRIENDLY);
    } else {
      return this.httpClient.put(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_BAN_FRIENDLY, reqBody, httpOptions);
    }
  }

  accountPasswordChange(ban?: string, logonId?: string, oldPassword?: string, newPassword?: string, email?: string) {
    this.orgID = this._helperUtilSvc.getOrgID();
    const httpOptions = this.setHeaders();
    const reqBody = {
      logonId: logonId,
      oldPassword: oldPassword,
      newPassword: newPassword,
      email: email,
      orgId: this.orgID,
      ban: ban
    };

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APGIEE_ACCOUNT_PASSWORD_CHANGE);
    } else {
      return this.httpClient.put(this._envSvc.APIGEE_TOKEN_URLS.APGIEE_ACCOUNT_PASSWORD_CHANGE, reqBody, httpOptions);
    }
  }
  getPaperlessBillingDetails(ban) {
    const httpOptions = this.setHeaders();
    const reqBody = {
      billingAccount: ban
    };
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.PAPERLESS_BILLING);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.PAPERLESS_BILLING, reqBody, httpOptions);
    }
  }

  getBusinessAdvisement(requestPayload) {
    const httpOptions = this.setHeaders();
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SERVICE_AGREEMENT);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.BUSINESS_ADVISEMENT, requestPayload, httpOptions);
    }
  }

  getTermsAndConditions(body) {
    const httpOptions = this.setHeaders();
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_TERMS_CONDITIONS);
    } else {
      const termsUrl = this.httpClient.regeneratePath(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_TERMS_CONDITIONS,
        this._envSvc.APIGEE_TOKEN_URLS.APIGEE_TERMS_CONDITIONS.path);
      return this.httpClient.post(termsUrl, body, httpOptions);
    }
  }

  enrollPaperlessBilling(body) {
    const httpOptions = this.setHeaders();
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.PAPERLESS_BILLING_ENROLL);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.PAPERLESS_BILLING_ENROLL, body, httpOptions);
    }
  }
  unenrollPaperlessBilling(body) {
    const httpOptions = this.setHeaders();
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.PAPERLESS_BILLING_UNENROLL);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.PAPERLESS_BILLING_UNENROLL, body, httpOptions);
    }
  }
  editPaperlessBilling(body) {
    const httpOptions = this.setHeaders();
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.PAPERLESS_BILLING_EDIT);
    } else {
      return this.httpClient.put(this._envSvc.APIGEE_TOKEN_URLS.PAPERLESS_BILLING_EDIT, body, httpOptions);
    }
  }

  getPortInPST_Date() {
    const httpOptions = this.setHeaders();

    const portDate_PST = _.cloneDeep(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_PORTIN_PST_DATE);

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(portDate_PST);
    } else {
      return this.httpClient.get(portDate_PST, httpOptions);
    }
  }

  getLockStatus(imeiNumber) {
    const httpOptions = this.setHeaders();
    const reqBody = {
      imei: imeiNumber,
    };
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_LOCK_STATUS);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_LOCK_STATUS, reqBody, httpOptions);
    }
  }


  validateSimSWapAuth(){
    const httpOptions =
    {
      ...this.setHeaders(),
      params: {
        'noCache': Date.now()
      }
    }
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.SIM_SWAP_AUTH);
    } else {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.SIM_SWAP_AUTH, httpOptions);
    }
  }

  getDeviceQueryDetails(accountId) {
    const httpOptions = this.setHeaders();
    const reqBody = {
      accountId: accountId,
      pageNumber: COMMON_CONSTANTS.DIGITS.ONE,
      pageSize: COMMON_CONSTANTS.DIGITS.THOUSANDS,
      ban : this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN) || ""
    };
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_DEVICE_QUERY);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_DEVICE_QUERY, reqBody,httpOptions);
    }
  }

  getStackablePlan(ban) {
    const httpOptions = this.setHeaders();
    const reqBody = {
      billingAccountNumber: ban,
      group:'ALL'
    };
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_STACKABLE_PLAN);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_STACKABLE_PLAN, reqBody,httpOptions);
    }
  }

  getSubscribeDetailsAhubV4(payload) {
    const httpOptions = this.setHeadersConfiguratoinSubscriber();
    const subscriberV4URL = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_POST_V4_SUBSCRIBERS;
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(subscriberV4URL);
    } else {
      return this.httpClient.post(subscriberV4URL, payload, httpOptions);
    }
  }
  getIOTProductConfigurations(payload) {
    const httpOptions = this.setHeaders();
    const iotProductConfig = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_IOT_PRODUCT_CONFIG;
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(iotProductConfig);
    } else {
      return this.httpClient.post(iotProductConfig, payload, httpOptions);
    }
  }

  getBusinessCustomerSubscription(ban) {
    const httpOptions = this.setHeaders();
    const reqBody = {
      "billingAccountNumber": ban,
      "billingSystemName": "SAMSON"
    }
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_BUSINESS_CUSTOMER_SUBSCRIPTION);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_BUSINESS_CUSTOMER_SUBSCRIPTION, reqBody,httpOptions);
    }
  }



  dialpadOrderApi(OrderId:any) {
  let logonId= JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));

    const httpOptions = this.setHeaders();
    const reqBody = {
        "credentials": {
          "logonId": logonId?.logonID || "",
        },
        "orderId": OrderId,
        ban : this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN)
      }

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SUBMIT_CART);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SUBMIT_CART, reqBody, httpOptions);
    }

  }

  removePackageFromCart(catItem) {
  let logonId= JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));

    const httpOptions = {
      ...this.setHeaders(),
      params:{cartID:catItem?.orderId,packageID:catItem?.packageId}
    }

    const payload = {
      "credentials": {
        "logonId":  logonId?.logonID || ""
      },
      "forceUpdate": true
    }

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.REMOVE_PACKAGE_FROM_CART);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.REMOVE_PACKAGE_FROM_CART, payload, httpOptions);
    }

  }

  createCart(payload){
    let logonId= JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));

    payload["credentials"]={logonId:logonId?.logonID|| ""};
    const httpOptions = this.setHeaders();

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_CREATE_CART);
    } else {
      return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_CREATE_CART, payload, httpOptions);
    }
  }

  validateCart(cartId: any) {
    let httpOptions: any = this.setHeaders();
    httpOptions.params = {
      cartID: cartId
    };

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_VALIDATE_CART);
    } else {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_VALIDATE_CART, httpOptions);
    }
  }

  bulkCancelSubscriberProcessor(requestBody) {
    let responseObj: any;
    const httpOptions = this.setHeaders();
    const url = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_BULK_CANCEL_SUBSCRIBER;
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_BULK_SUSPEND);
    } else {
      responseObj = this.httpClient.post(url, requestBody, httpOptions);
    }
    return responseObj;
  }

  bulkChangeServiceProcessor(requestBody) {
    let responseObj: any;
    const httpOptions = this.setHeaders();
    const url = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_BULK_CHANGE_SERVICE;
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_BULK_SUSPEND);
    } else {
      responseObj = this.httpClient.post(url, requestBody, httpOptions);
    }
    return responseObj;
  }

  is_Iam_ML_PTT__activitydisabledenabled(linedetails,actitytypename){
    if(environment.ENABLE_ML_PTT_FEATURE){
      if(linedetails.productType === BULK_UPLOAD.PRODUCT_TYPE_B &&
        linedetails.lineSubType === MANAGE_LINE_CONST.LINE_SUBTYPE_TDC &&
         linedetails.lineType === MANAGE_LINE_CONST.LINETYPE_VALUE){// if the selected line is PTT ?
          return [COMMON_CONSTANTS.ACTION_HYPERLINK.CHANGE_SIM ,COMMON_CONSTANTS.ACTION_HYPERLINK.CHANGE_NUMBER ,
             COMMON_CONSTANTS.ACTION_HYPERLINK.CHANGE_RATE_PLAN ,COMMON_CONSTANTS.ACTION_HYPERLINK.TANSFER_NUMBER].includes(actitytypename)
      }else if (linedetails.productType === BULK_UPLOAD.PRODUCT_TYPE_B &&
        linedetails.lineSubType === MANAGE_LINE_CONST.LINE_SUBTYPE_ML &&
         linedetails.lineType === MANAGE_LINE_CONST.LINETYPE_VALUE){// if the selected line is ML ?
          return [COMMON_CONSTANTS.ACTION_HYPERLINK.CHANGE_SIM].includes(actitytypename);
        }
        else{
          return false  // if the selected line NOT ML OR NOT PTT ?
        }
      }else{
      return false
    }

  }
  ///

  is_line_ML_PTT(linedetails){
    if(environment.ENABLE_ML_PTT_FEATURE){
      if(linedetails?.productType === BULK_UPLOAD.PRODUCT_TYPE_B &&
        linedetails.lineSubType === MANAGE_LINE_CONST.LINE_SUBTYPE_TDC &&
         linedetails.lineType === MANAGE_LINE_CONST.LINETYPE_VALUE){// if the selected line is PTT ?
          sessionStorage.setItem(COMMON_CONSTANTS.SELECTED_LINE_SUBTYPE, MANAGE_LINE_CONST.SUBLINETYPE_PTT);
      }else if (linedetails?.productType === BULK_UPLOAD.PRODUCT_TYPE_B &&
        linedetails.lineSubType === MANAGE_LINE_CONST.LINE_SUBTYPE_ML &&
         linedetails.lineType === MANAGE_LINE_CONST.LINETYPE_VALUE){// if the selected line is ML ?
          sessionStorage.setItem(COMMON_CONSTANTS.SELECTED_LINE_SUBTYPE, MANAGE_LINE_CONST.SUBLINETYPE_ML);
        }
      }

  }

  filter_ML_PTT(response){
    let linesubtype = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.SELECTED_LINE_SUBTYPE);
    let linesubtypeArr = [MANAGE_LINE_CONST.SUBLINETYPE_ML, MANAGE_LINE_CONST.SUBLINETYPE_PTT];
    if(linesubtypeArr.includes(linesubtype)){
      response.eligibleServices.allServices = response?.eligibleServices?.allServices.filter((val) => {
        return (val.subLineType === linesubtype);
      });
    }
  }

 filter_IDP_SOC(response){
         let idpSocList = IDP_SOC_LIST;
         if(!isNullOrUndefined(response?.currentServices?.allServices)){
           response.currentServices.allServices = response?.currentServices?.allServices.filter((val) => {
             return (idpSocList.includes(val.soc) === false);
             });
         }
         if(!isNullOrUndefined(response?.eligibleServices?.allServices)){
          response.eligibleServices.allServices = response?.eligibleServices?.allServices.filter((val) => {
            return (idpSocList.includes(val.soc) === false);
            });
         }
  }
  // cat_tool_api

  getCatToolApi() {
      const httpOptions = this.setHeaders();
      const reqBody = {
        billingAccount : this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN)
        }

      if (environment.mocked_all || environment.mocked_endpoints) {
        return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_CAT_TOOL_LINK);
      } else {
        return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_CAT_TOOL_LINK, reqBody, httpOptions);
      }

    }

    getDelinquencyStatus(businessSegment, ban){
      const httpOptions = this.setHeaders();
      const reqBody = {
        "transactionType": "LOOKUP",
        "businessSegment": businessSegment,
        "accountNumber": ban
      }
      if (environment.mocked_all || environment.mocked_endpoints) {
        return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_DELINQUENCY_STATUS);
      } else {
        return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_DELINQUENCY_STATUS, reqBody, httpOptions);
      }
    }

    submitBulkRequest(request) {
      const httpOptions = this.setHeaders();
      if (environment.mocked_all || environment.mocked_endpoints) {
        return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_BULK_UPLOAD);
      } else {
        return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_BULK_PROCESSOR, request, httpOptions);
      }
    }

    getStrategicPortInPubKey() {
      const httpOptions = this.setHeaders();
      if (environment.mocked_all || environment.mocked_endpoints) {
        return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_STRATEGIC_PORT_IN_PK);
      } else {
        return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_STRATEGIC_PORT_IN_PK, httpOptions);
      }
    }

    getBulkLineDetails(requestBody) {
      const httpOptions = this.setHeaders();
      if (environment.mocked_all || environment.mocked_endpoints) {
        return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.BULK_LINE_DETAILS);
      } else {
        return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.BULK_LINE_DETAILS, requestBody, httpOptions);
      }
    }

    fetchUserNotifyContact(requestBody) {
      const httpOptions = this.setHeaders();
      if (environment.mocked_all || environment.mocked_endpoints) {
        return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.FETCH_USER_NOTIFY_CONTACT);
      } else {
        return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.FETCH_USER_NOTIFY_CONTACT, requestBody, httpOptions);
      }
    }

    removeUserNotifyContact(requestBody) {
      const httpOptions = this.setHeaders();
      if (environment.mocked_all || environment.mocked_endpoints) {
        return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.REMOVE_USER_NOTIFY_CONTACT);
      } else {
        return this.httpClient.post(this._envSvc.APIGEE_TOKEN_URLS.REMOVE_USER_NOTIFY_CONTACT, requestBody, httpOptions);
      }
    }

    updateUserNotifyContact(requestBody) {
      const httpOptions = this.setHeaders();
      if (environment.mocked_all || environment.mocked_endpoints) {
        return this.httpClient.get(this._envSvc.APIGEE_TOKEN_URLS.UPDATE_USER_NOTIFY_CONTACT);
      } else {
        return this.httpClient.put(this._envSvc.APIGEE_TOKEN_URLS.UPDATE_USER_NOTIFY_CONTACT, requestBody, httpOptions);
      }
    }

    fetchBlockStatus(ban, isEndUser?) {
      const reqBody = this.fetchBlockStatusReqBody(ban, isEndUser);
      const httpOption = this.setHeaders();
      const url = this._envSvc.APIGEE_TOKEN_URLS.FETCH_BLOCK_STATUS;

      if (environment.mocked_all || environment.mocked_endpoints) {
        return this.httpClient.get(url);
      } else {
        return this.httpClient.post(url, reqBody, httpOption);
      }
    }

    fetchBlockStatusReqBody(ban, isEndUser): any {
      let msisdn = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.SELECTED_MSISDN);
      return {
        ban,
        ...(isEndUser ? { msisdns: [msisdn] } : {})
      };
    }

    manageBlockStatus(requestBody) {
      const httpOption = this.setHeaders();
      const url = this._envSvc.APIGEE_TOKEN_URLS.MANAGE_BLOCK_STATUS;

      if (environment.mocked_all || environment.mocked_endpoints) {
        return this.httpClient.get(url);
      } else {
        return this.httpClient.post(url, requestBody, httpOption);
      }
    }

    manageTransactionStatus(requestBody) {
      const httpOption = this.setHeaders();
      const url = this._envSvc.APIGEE_TOKEN_URLS.MANAGE_TRANSACTION_STATUS;
      if (environment.mocked_all || environment.mocked_endpoints) {
        return this.httpClient.get(url);
      } else {
        return this.httpClient.post(url, requestBody, httpOption);
      }
    }

    genratePortOutPin(requestBody) {
      const httpOption = this.setHeaders();   
      const url = this._envSvc.APIGEE_TOKEN_URLS.GENERATE_PORT_OUT_PIN;
      if (environment.mocked_all || environment.mocked_endpoints) {
        return this.httpClient.get(url);
      } else {
        return this.httpClient.post(url, requestBody, httpOption);
      }
    }    

    getPortOutPin(requestBody) {
      const httpOption = this.setHeaders();   
      const url = this._envSvc.APIGEE_TOKEN_URLS.GET_PORT_OUT_PIN;
      if (environment.mocked_all || environment.mocked_endpoints) {
        return this.httpClient.get(url);
      } else {
        return this.httpClient.post(url, requestBody, httpOption);
      }
    }    



    genratePortOutPinmulti(requestBody) {
      const httpOption = this.setHeaders();   
      const url = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_BULK_SERVICE_RESTORE;
      if (environment.mocked_all || environment.mocked_endpoints) {
        return this.httpClient.get(url);
      } else {
        return this.httpClient.post(url, requestBody, httpOption);
      }
    }    




    portOutPinCancellation(requestBody) {
      const httpOption = this.setHeaders();   
      const url = this._envSvc.APIGEE_TOKEN_URLS.PORT_OUT_PIN_CANCELLATION;
      if (environment.mocked_all || environment.mocked_endpoints) {
        return this.httpClient.get(url);
      } else {
        return this.httpClient.post(url, requestBody, httpOption);
      }
    }    
}
